import styled from 'styled-components';

export const FallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const FallbackMsg = styled.h1`
  font-size: 18px;
  font-weight: 300;
  color: ${({ theme }) => theme.lpbDashboard.colors.fallbackMsgColor};
`;
